// generated by genversion
const version = '6.14.1';

export { version };
//# sourceMappingURL=version.mjs.map
